import React from 'react';
import { motion } from 'framer-motion';
const useCases = [{
  title: 'Software vendors (SaaS)',
  description: 'Sell accounting practice management software, tax tools, or cybersecurity solutions directly to managing partners using our accounting email list.',
  quote: 'The accounting database coverage helped us reach 3x more qualified prospects than our previous provider.',
  author: 'Sarah K., VP of Sales'
}, {
  title: 'Financial services',
  description: 'Partner with CPAs for wealth management referrals, business lending, or specialized tax credit consulting (like ERTC or R&D credits).',
  quote: 'Direct access to accounting firm owners cut our sales cycle in half.',
  author: 'Michael R., Business Development'
}, {
  title: 'Marketing agencies',
  description: 'Pitch SEO, website redesign, and lead generation services to accounting firms looking to grow their local client base.',
  quote: 'We can now target accounting firms by specialization and location with precision.',
  author: 'Elena T., Agency Owner'
}, {
  title: 'B2B service providers',
  description: 'Offer recruiting, answering services, IT support, or office supplies to established accounting businesses across the US.',
  quote: 'The verified email list quality is unmatched. Our bounce rate dropped to under 2%.',
  author: 'David L., Head of Growth'
}];
export function AccountingUseCases() {
  return <section className="py-24 bg-white" data-id="element-483">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-484">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-485">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 leading-tight" data-id="element-486">
            Who uses our{' '}
            <span className="text-blue-600" data-id="element-487">accounting owner contacts?</span>
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-488">
            When you buy accounting leads from Openmart, you get direct access
            to decision-makers. Here is how our clients use the accounting
            business database.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-20 gap-y-2" data-id="element-489">
          {useCases.map((useCase, index) => <motion.div key={useCase.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          ease: [0.22, 1, 0.36, 1],
          delay: index * 0.08
        }} className={`py-12 group ${index < 2 ? 'border-b border-slate-200' : ''}`} data-id="element-490">
              <div className="relative mb-6" data-id="element-491">
                <div className="text-7xl md:text-8xl font-bold text-blue-100 absolute -top-6 -left-3 z-0 select-none" data-id="element-492">
                  0{index + 1}
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-slate-900 relative z-10 pt-4 md:pt-6" data-id="element-493">
                  {useCase.title}
                </h3>
              </div>
              <p className="text-base md:text-lg text-slate-600 leading-relaxed mb-6" data-id="element-494">
                {useCase.description}
              </p>
              <div className="pl-5 border-l-2 border-blue-200" data-id="element-495">
                <p className="text-sm md:text-base text-slate-700 italic leading-relaxed mb-2" data-id="element-496">
                  "{useCase.quote}"
                </p>
                <p className="text-xs md:text-sm font-medium text-blue-600/70 uppercase tracking-wide" data-id="element-497">
                  {useCase.author}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}